export default __webpack_public_path__ + "static/media/server.5e484f52.svg";